.card {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: var(--docs-card);
	text-decoration: none !important;
	color: inherit !important;

	&:hover {
		background: var(--docs-card-hover);

		.image {
			transform: scale(1.03);
		}

		.description {
			color: var(--mantine-color-text);
		}
	}

	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}

// The thumbnails are 16:9 crops, so a fixed ratio keeps a row of cards level
// even before the images load.
.thumb {
	aspect-ratio: 16 / 9;
	overflow: hidden;
	background: #14110d;
}

.image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 300ms ease;
}

.body {
	flex: 1;
}

.description {
	transition: color 200ms ease;
}
